import React from "react";
export const CardContext = React.createContext("");